import { SpinResponse } from '@cgs/data-access';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  GameStateMachine,
  IGameStateMachineProvider,
} from '@cgs/machines';
import { TRIFECTA_SDK_ADAPTER_TOKEN, TrifectaSDKAdapter } from '@cgs/provider-trifecta';
import { Container } from '@cgs/wge';

export const CORSICA_BONUS_HUD_VISIBILITY_COMPONENT_TOKEN = Symbol(
  'CORSICA_BONUS_HUD_VISIBILITY_COMPONENT_TOKEN'
);

// Hides the Trifecta SDK HUD container while the bonus game is playing and
// shows it again once the bonus finishes.
export class CorsicaBonusHudVisibilityComponent {
  constructor(container: Container) {
    const sdkAdapter = container.resolve<TrifectaSDKAdapter>(TRIFECTA_SDK_ADAPTER_TOKEN);
    const gameStateMachine = container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine as GameStateMachine<SpinResponse>;

    gameStateMachine.beginBonus.entered.listen(() => sdkAdapter.hideContainer());
    gameStateMachine.bonus.entered.listen(() => sdkAdapter.hideContainer());
    gameStateMachine.endBonus.leaved.listen(() => sdkAdapter.showContainer());
  }
}
